import { createFileRoute, redirect } from '@tanstack/react-router'

import PendingComponent from '@/components/pending-component'
import { Permission } from '@/lib/permissions'

export const Route = createFileRoute('/_dashboard/site/$id/alerts/create/')({
  pendingComponent: PendingComponent,
  beforeLoad({ context }) {
    if (!context.user?.hasPermission(Permission.ALERT_CONFIGURATION) && !context.user?.hasPermission(Permission.EDIT_ALL)) {
      throw redirect({
        to: '/403',
      })
    }
  },
})
